module.exports = __webpack_public_path__ + "media/images/icons/filled/alipay-circle-819a14614ca3619393e8f5bc706b2313.svg";